import { IAvailableLanguageChoices } from "@/model/lang/choice";

const AvailableLanguages: IAvailableLanguageChoices = {
    "en-gb" : "English",
    "fr" : "Français",
    "zh": "繁體中文"
};

export { AvailableLanguages };
